import React from 'react';
import { Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import i18n from '@/utils/i18n';

type AssetsUpdatesProps = {
  oldAssetIds: string[];
  newAssetIds: string[];
};

const AssetsUpdates = ({ oldAssetIds, newAssetIds }: AssetsUpdatesProps) => {
  const removedAssets = oldAssetIds?.filter(
    (id: string) => !newAssetIds?.includes(id),
  );
  const addedAssets = newAssetIds?.filter(
    (id: string) => !oldAssetIds?.includes(id),
  );

  const hasBeenAdded = addedAssets.length > 0;
  const hasBeenRemoved = removedAssets.length > 0;

  // Show both added and removed assets
  const allChangedAssets = [...addedAssets, ...removedAssets];

  return (
    <Table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>{i18n.t('TrackableItems:asset')}</th>
          <th>{i18n.t('OrderFulfillment:change')}</th>
        </tr>
      </thead>
      <tbody>
        {addedAssets.map((assetId) => (
          <tr key={`added-${assetId}`}>
            <td>
              <Link to={`/trackable-item/${assetId}`}>{assetId}</Link>
            </td>
            <td>
              <div className="text-success">
                {i18n.t('OrderFulfillment:added')}
              </div>
            </td>
          </tr>
        ))}
        {removedAssets.map((assetId) => (
          <tr key={`removed-${assetId}`}>
            <td>
              <Link to={`/trackable-item/${assetId}`}>{assetId}</Link>
            </td>
            <td>
              <div className="text-danger">
                {i18n.t('OrderFulfillment:removed')}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AssetsUpdates;
